import { NameDto } from '../../Common/Types'

export interface TokenizedCardDetails {
  id: string
  tokenId: string
  tokenCreatedDate: string
  paymentMethod: NameDto<string>
  maskedCardNumber: string
  cardholderName: string
  expirationDate: string
  status: NameDto
  comment: string
}

export interface UpdateTokenizedCardholderName {
  cardHolderName: string
  comment: string
}

export interface UpdateTokenizedCardStatus {
  statusId: number
  comment: string
}

export enum TokenizedCardStatus {
  ACTIVE = 1,
  EXPIRED = 2,
  CLOSED = 3,
}
